namespace SorAraBul.PropertyManagement {

    /**
     * An order wizard that extends Serenity.WizardDialog, available only in premium version
     */

    @Serenity.Decorators.panel()
    export class FormWizard extends Serenity.WizardDialog<PropertyManagement.TenantDetailRow, any> {
        protected getFormKey() { return TenantWizardForm.formKey; }
        protected getLocalTextPrefix() { return "PropertyManagement.TenantWizardForm"; }

        protected form = new TenantWizardForm(this.idPrefix);

        private GId: string;
        private InsertDate: Date;
        private hasoReportRetryCount = 0;
        private hasoRetryDialog: JQuery;
        private readonly otherOccupationId = 7765;

        getInitialEntity() {

            var ent: TenantDetailRow;

            SorAraBul.PropertyManagement.TenantDetailService.Retrieve({
                EntityId: window.location.pathname.split("/")[2]
            }, response => {
                ent = response.Entity;

                //Bu alanlar boşsa Ev sahibinin girdiği Kiracı bilgileri varsayılan olarak gelsin
                ent.SelfReportedEmail = ent.SelfReportedEmail ? ent.SelfReportedEmail : ent.TenantEmail;
                ent.SelfReportedName = ent.SelfReportedName ? ent.SelfReportedName : ent.TenantName;
                ent.SelfReportedSurname = ent.SelfReportedSurname ? ent.SelfReportedSurname : ent.TenantSurname;
                ent.SelfReportedPhone = ent.SelfReportedPhone ? ent.SelfReportedPhone : ent.TenantPhone;

                var oldAddressDurationMonths = (ent as any).OldAddressResidenceDurationMonths;
                if (oldAddressDurationMonths != null) {
                    (ent as any).OldAddressResidenceDurationYears = Math.floor(oldAddressDurationMonths / 12);
                    (ent as any).OldAddressResidenceDurationRemainingMonths = oldAddressDurationMonths % 12;
                }

                this.InsertDate = Q.parseDate(response.Entity.InsertDate);

                this.step = ent.Step;

            }, { async: false });

            return ent;
        }

        constructor() {
            super();
            var self = this;
            SorAraBul.Common.preventAutofill([
                self.form.OldCityId,
                self.form.OldTownId,
                self.form.OldQuarterId
            ]);
            this.dialogTitle = "";
            this.element.find(".buttons .btn-danger").remove();
            this.GId = window.location.pathname.split("/")[2];

            //Geri butonu gizle
            this.byId("BackButton").hide();

            this.enableNumericKeyboard(this.form.ChildrenCount);
            this.enableNumericKeyboard(this.form.WorkingAdultsCount);
            this.enableNumericKeyboard(this.form.OldAddressResidenceDurationYears);
            this.enableNumericKeyboard(this.form.OldAddressResidenceDurationRemainingMonths);
            this.configureOccupationEditors();

            //VALİDASYONLAR BAŞLANGIÇ
            //(AYNI VALİDASYONLAR CompanyDialog İÇERİSİNDE DE VAR.BURADA YAPILAN DEĞİŞİKLİKLERİ ORAYA DA UYGULA. ORTAK HALE GETİRİLECEK)


            this.form.MaritalStatus.change(e => {
                var res = this.form.MaritalStatus.value == MaritalStatus.evli.toString() ? true : false;

                Serenity.EditorUtils.setReadOnly(this.form.OccupationSpouseId, !res);
                Serenity.EditorUtils.setRequired(this.form.OccupationSpouseId, res);
                this.form.OccupationSpouseId.value = res ? this.form.OccupationSpouseId.value : "";
                this.form.OccupationSpouse.value = res ? this.form.OccupationSpouse.value : "";
                this.updateOccupationManualEditor(this.form.OccupationSpouseId, this.form.OccupationSpouse, false);

                Serenity.EditorUtils.setReadOnly(this.form.EducationLevelSpouse, !res);
                Serenity.EditorUtils.setRequired(this.form.EducationLevelSpouse, res);
                this.form.EducationLevelSpouse.value = res ? this.form.EducationLevelSpouse.value : "";

            });
            this.form.MaritalStatus.element.trigger("change");


            this.form.HasChildren.change(e => {
                var res = this.form.HasChildren.value == "1" ? true : false;

                Serenity.EditorUtils.setReadOnly(this.form.ChildrenCount, !res);
                Serenity.EditorUtils.setRequired(this.form.ChildrenCount, res);
                this.form.ChildrenCount.value = res ? this.form.ChildrenCount.value : null;

                Serenity.EditorUtils.setReadOnly(this.form.ChildrenAges, !res);
                Serenity.EditorUtils.setRequired(this.form.ChildrenAges, res);
                this.form.ChildrenAges.value = res ? this.form.ChildrenAges.value : "";

            });
            this.form.HasChildren.element.trigger("change");


            this.form.HasPet.change(e => {
                var res = this.form.HasPet.value == "1" ? true : false;

                Serenity.EditorUtils.setReadOnly(this.form.PetTypes, !res);
                Serenity.EditorUtils.setRequired(this.form.PetTypes, res);
                this.form.PetTypes.value = res ? this.form.PetTypes.value : "";

            });
            this.form.HasPet.element.trigger("change");


            const termsField = this.byId('TermsAccepted').closest('.field');

            // Daha önce eklenmiş mi kontrol et (class bazlı daha güvenli)
            if (termsField.find('.haso-terms-span').length === 0) {

                // <a> etiketli span metni
                const span = $(`
                <span class="haso-terms-span">
                    <a href="javascript:void(0);" class="haso-link">Kullanım Koşulları</a>'nı okudum, onaylıyorum.
                </span>
                `);

                // Tıklanınca popup aç
                span.find('.haso-link').on('click', () => {
                    new SorAraBul.PropertyManagement.HasoTermsDialog().dialogOpen();
                });

                // Checkbox alanına ekle
                termsField.append(span);
            }

            //VALİDASYONLAR - BİTİŞ

        }

        private enableNumericKeyboard(editor: Serenity.IntegerEditor) {
            editor.element.attr({
                inputmode: 'numeric',
                pattern: '[0-9]*',
                autocomplete: 'off'
            });
        }

        private configureOccupationEditors() {
            this.form.OccupationSelfId.change(() =>
                this.updateOccupationManualEditor(this.form.OccupationSelfId, this.form.OccupationSelf, true));

            this.form.OccupationSpouseId.change(() =>
                this.updateOccupationManualEditor(this.form.OccupationSpouseId, this.form.OccupationSpouse, true));

            this.updateOccupationManualEditor(this.form.OccupationSelfId, this.form.OccupationSelf, false);
            this.updateOccupationManualEditor(this.form.OccupationSpouseId, this.form.OccupationSpouse, false);
        }

        private updateOccupationManualEditor(lookupEditor: Serenity.ServiceLookupEditor, textEditor: Serenity.StringEditor, clearManualWhenOtherSelected: boolean) {
            var isOther = lookupEditor.value === this.otherOccupationId.toString();
            var selectedText = this.getSelectedLookupText(lookupEditor);
            var manualField = textEditor.element.closest('.field');

            manualField.css('visibility', isOther ? 'visible' : 'hidden');
            Serenity.EditorUtils.setRequired(textEditor, isOther);

            if (!isOther) {
                textEditor.value = selectedText;
                return;
            }

            if (clearManualWhenOtherSelected)
                textEditor.value = "";
        }

        private getSelectedLookupText(editor: Serenity.ServiceLookupEditor): string {
            var selected = editor.element.select2('data');

            if ($.isArray(selected))
                return selected.length ? selected[0].text : "";

            return selected && selected.text ? selected.text : "";
        }


        /**
         * next method is called when user tries to go forward
         * @param toStep the step user is trying to move to, usually one step ahead
         */
        protected next(toStep: number) {
            var self = this;

            if (this.step == FormWizardSteps.HasoInfoAndContractApproval) {

                // Checkbox değerini kontrol et
                if (!this.form.TermsAccepted.value) {

                    // Hata mesajını göster (visual olarak input'a da)
                    this.validator.showErrors({
                        [this.form.TermsAccepted.element.attr("name")]: "Devam etmek için kullanım koşullarını onaylamalısınız."
                    });

                    Q.notifyError("Devam etmek için kullanım koşullarını onaylamalısınız.");

                    return; // ilerlemeyi durdur
                }

                if (!this.validateHasoInfoStep())
                    return;

                this.openHasoConsentDialog(toStep);
            }
            else if (this.step == FormWizardSteps.GeneralInformation) {

                SorAraBul.PropertyManagement.TenantDetailService.Update({
                    EntityId: self.GId,
                    Entity: this.getSaveEntity([FormWizardSteps.GeneralInformation]) as SorAraBul.PropertyManagement.TenantDetailRow
                }, response => {
                    this.step = toStep;
                });
            }
            else if (this.step == FormWizardSteps.InformationRequiredForTheReport) {
                this.step = toStep;
            }

            // you should call setStep after validating / modifying target step (toStep)
        }

        /**
         * back method is called when user tries to go backward
         * @param toStep the step user is trying to move to, usually one step back but can also be multiple
         */
        protected back(toStep: number) {

            //this.step = toStep;
        }

        /**
         * called to reset the form, and go back to first step
         */
        protected reset() {
            super.reset();

            // we need to clear readonly / required state of existing customer selection
            // as base reset method won't reset its state, only form values
        }

        private validateHasoInfoStep(): boolean {
            var errors: string[] = [];

            if (!Q.trimToNull(this.form.SelfReportedEmail.value))
                errors.push("E-posta adresi zorunludur.");

            if (!Q.trimToNull(this.form.TcknInput.value))
                errors.push("TC kimlik numarası zorunludur.");

            if (!Q.trimToNull(this.form.SelfReportedName.value))
                errors.push("Ad zorunludur.");

            if (!Q.trimToNull(this.form.SelfReportedSurname.value))
                errors.push("Soyad zorunludur.");

            if (!Q.trimToNull(this.form.SelfReportedPhone.value))
                errors.push("Cep telefonu zorunludur.");

            if (!Q.trimToNull(this.form.BirthDate.value))
                errors.push("Doğum tarihi zorunludur.");

            if (errors.length) {
                Q.notifyError(errors.join("<br/>"));
                return false;
            }

            return true;
        }

        private createHasoInfoEntity(): TenantDetailRow {
            var entity = this.getSaveEntity([FormWizardSteps.HasoInfoAndContractApproval]) as TenantDetailRow;
            entity.Tckn = this.form.TcknInput.value;
            delete entity["TcknInput"];
            delete entity["TermsAccepted"];

            return entity;
        }

        private openHasoConsentDialog(toStep: number) {
            var dialog = $(`
                <div class="haso-consent-dialog">
                    <div class="haso-consent-brand">
                        <span class="haso-consent-badge"><i class="fa fa-check-circle-o"></i></span>
                        <span>HASO Check Platform</span>
                    </div>
                    <div class="haso-consent-preview">
                        <div class="haso-sms-preview-list">
                            <img src="/Content/site/images/findeks-sms.jpeg" alt="Findeks SMS örneği" class="haso-sms-preview-image" />
                            <span class="haso-sms-preview-separator">veya</span>
                            <img src="/Content/site/images/haso-sms.jpeg" alt="HASO SMS örneği" class="haso-sms-preview-image" />
                        </div>
                    </div>
                    <p class="haso-consent-text">
                        Finansal değerlendirmenizin tamamlanabilmesi için <b>Kredi Kayıt Bürosu (Findeks)</b>
                        üzerinden raporunuz sorgulanacaktır. Süreç sırasında telefonunuza SMS onay kodu
                        gönderilebilir; yakın zamanda onay verdiyseniz SMS gelmeden rapor sonucu alınabilir.
                    </p>
                    <div class="haso-consent-actions">
                        <button type="button" class="btn btn-outline-secondary haso-decline-button">Şu an onay vermek istemiyorum</button>
                        <button type="button" class="btn btn-primary haso-approve-button">Onaylıyorum ve devam ediyorum</button>
                    </div>
                </div>`);

            dialog.find('.haso-approve-button').on('click', () => {
                dialog.dialog('close');
                this.startHasoAuth(toStep);
            });

            dialog.find('.haso-decline-button').on('click', () => {
                dialog.dialog('close');
                this.openMissingReportWarningDialog(toStep);
            });

            dialog.dialog({
                modal: true,
                title: "HASO (Hızlı Aday Sorgulama Onayı)",
                width: 560,
                dialogClass: "haso-consent-modal",
                close: () => dialog.dialog('destroy').remove()
            });
        }

        private openMissingReportWarningDialog(toStep: number) {
            var dialog = $(`
                <div class="haso-missing-report-dialog">
                    <div class="haso-warning-icon"><i class="fa fa-exclamation-triangle"></i></div>
                    <h3>Eksik Rapor Uyarısı</h3>
                    <p>
                        Finansal rapor onayı vermeden devam ederseniz, başvurunuzda finansal verileriniz
                        eksik görünecektir. Bu durum mülk sahibinin değerlendirme sürecini etkileyebilir.
                    </p>
                    <div class="haso-consent-actions haso-warning-actions">
                        <button type="button" class="btn btn-primary haso-back-consent-button">Fikrimi değiştirdim, onay sayfasına dön</button>
                        <button type="button" class="btn btn-outline-secondary haso-continue-without-report-button">Anladım, yine de devam et</button>
                    </div>
                </div>`);

            dialog.find('.haso-back-consent-button').on('click', () => {
                dialog.dialog('close');
                this.openHasoConsentDialog(toStep);
            });

            dialog.find('.haso-continue-without-report-button').on('click', () => {
                dialog.dialog('close');
                this.skipHasoAndContinue(toStep);
            });

            dialog.dialog({
                modal: true,
                title: "",
                width: 500,
                dialogClass: "haso-missing-report-modal",
                close: () => dialog.dialog('destroy').remove()
            });
        }

        private startHasoAuth(toStep: number) {
            Q.serviceCall({
                service: SorAraBul.PropertyManagement.TenantDetailService.baseUrl + '/StartHasoAuth',
                request: {
                    EntityId: this.GId,
                    Entity: this.createHasoInfoEntity()
                },
                onSuccess: (response: TenantDetailHasoProcessResponse) => {
                    this.hasoReportRetryCount = 0;
                    this.handleHasoResponse(response, toStep, true);
                }
            });
        }

        private skipHasoAndContinue(toStep: number) {
            Q.serviceCall({
                service: SorAraBul.PropertyManagement.TenantDetailService.baseUrl + '/SkipHasoAuth',
                request: {
                    EntityId: this.GId,
                    Entity: this.createHasoInfoEntity()
                },
                onSuccess: (response: TenantDetailHasoProcessResponse) => {
                    this.step = toStep;
                }
            });
        }

        private handleHasoResponse(response: TenantDetailHasoProcessResponse, toStep: number, allowPinDialog: boolean) {
            if (!response) {
                Q.notifyError("Servisten cevap alınamadı.");
                return;
            }

            if (response.Status === "Completed") {
                if (this.hasoRetryDialog)
                    this.hasoRetryDialog.dialog('close');

                this.step = toStep;
                return;
            }

            if (response.Status === "PinRequired") {
                if (allowPinDialog)
                    this.openSmsCodeDialog(toStep);
                else
                    Q.notifyInfo(response.Message || "Lütfen SMS doğrulama kodunu girin.");

                return;
            }

            if (response.Status === "RetryRequired") {
                this.openReportRetryDialog(toStep, response.Message);
                return;
            }

            this.showHasoError(response);
        }

        private openSmsCodeDialog(toStep: number) {
            SorAraBul.Common.SmsCodeDialog.ask({
                phone: this.form.SelfReportedPhone.value,
                resend: () => this.resendKkbPin(),
                resendCooldown: 300 // 300 olarak güncellenecek
            })
                .then(code => {
                    if (code == null)
                        return;

                    Q.serviceCall({
                        service: SorAraBul.PropertyManagement.TenantDetailService.baseUrl + '/SendKkbPinCode',
                        request: {
                            EntityId: this.GId,
                            PinCode: code
                        },
                        onSuccess: (response: TenantDetailHasoProcessResponse) => {
                            this.handleHasoResponse(response, toStep, false);
                        }
                    });
                })
                .fail(err => {
                    if (err)
                        Q.notifyError(Q.coalesce(err.message, "SMS doğrulama sırasında hata oluştu."));
                });
        }

        private resendKkbPin(): JQueryPromise<any> {
            var d = $.Deferred<any>();

            Q.serviceCall({
                service: SorAraBul.PropertyManagement.TenantDetailService.baseUrl + '/ReSendKkbPin',
                request: {
                    EntityId: this.GId
                },
                onSuccess: (response: TenantDetailHasoProcessResponse) => {
                    if (response.Status === "Error") {
                        this.showHasoError(response);
                        d.reject(response);
                        return;
                    }

                    if (response.Message)
                        Q.notifyInfo(response.Message);

                    d.resolve(response);
                },
                onError: response => {
                    d.reject(response);
                }
            });

            return d.promise();
        }

        private openReportRetryDialog(toStep: number, message: string) {
            if (this.hasoRetryDialog) {
                this.hasoRetryDialog.find('.haso-retry-message').text(message || "Rapor henüz hazır değil.");
                return;
            }

            this.hasoRetryDialog = $(`
                <div class="p-3">
                    <div class="haso-retry-message mb-2"></div>
                    <div class="haso-retry-countdown text-muted small"></div>
                </div>`);

            this.hasoRetryDialog.find('.haso-retry-message').text(message || "Rapor henüz hazır değil.");

            this.hasoRetryDialog.dialog({
                modal: true,
                title: "Rapor Sonucu",
                width: 430,
                close: () => {
                    this.hasoRetryDialog.dialog('destroy').remove();
                    this.hasoRetryDialog = null;
                },
                buttons: [
                    {
                        text: "Yeniden Deneyin",
                        class: "btn-primary haso-retry-button",
                        click: () => this.askKkbReportResult(toStep)
                    },
                    {
                        text: "Kapat",
                        click: () => this.hasoRetryDialog.dialog('close')
                    }
                ]
            });

            this.disableRetryButtonFor(10);
        }

        private askKkbReportResult(toStep: number) {
            if (this.hasoReportRetryCount >= 4) {
                Q.notifyError("Sistemde sorun yaşanmaktadır. Lütfen daha sonra tekrar deneyin.");
                if (this.hasoRetryDialog)
                    this.hasoRetryDialog.dialog('close');
                return;
            }

            this.hasoReportRetryCount++;
            this.disableRetryButtonFor(10);

            Q.serviceCall({
                service: SorAraBul.PropertyManagement.TenantDetailService.baseUrl + '/AskKkbReportResult',
                request: {
                    EntityId: this.GId
                },
                onSuccess: (response: TenantDetailHasoProcessResponse) => {
                    if (response.Status === "RetryRequired" && this.hasoReportRetryCount >= 4) {
                        Q.notifyError("Sistemde sorun yaşanmaktadır. Lütfen daha sonra tekrar deneyin.");
                        if (this.hasoRetryDialog)
                            this.hasoRetryDialog.dialog('close');
                        return;
                    }

                    if (response.Status === "RetryRequired" && this.hasoRetryDialog)
                        this.hasoRetryDialog.find('.haso-retry-message').text(response.Message || "Rapor henüz hazır değil.");

                    this.handleHasoResponse(response, toStep, false);
                }
            });
        }

        private disableRetryButtonFor(seconds: number) {
            if (!this.hasoRetryDialog)
                return;

            var button = this.hasoRetryDialog.closest('.ui-dialog').find('.haso-retry-button');
            var countdown = this.hasoRetryDialog.find('.haso-retry-countdown');
            var remain = seconds;

            button.prop('disabled', true);

            var tick = () => {
                countdown.text(`Yeniden denemek için ${remain} saniye bekleyin.`);
                remain--;

                if (remain < 0) {
                    countdown.text('');
                    button.prop('disabled', false);
                    return;
                }

                window.setTimeout(tick, 1000);
            };

            tick();
        }

        private showHasoError(response: TenantDetailHasoProcessResponse) {
            var message = response.Message;

            if ((!message || !message.length) && response.ErrorMessages && response.ErrorMessages.length)
                message = response.ErrorMessages.join("<br/>");

            Q.alert(message || "İşlemde hata oluştu.", {
                htmlEncode: false,
                title: "İşlem Tamamlanamadı"
            });
        }

        /**
         * is called when user clicks the Finish button (next button on last step)
         */
        protected finish() {


            this.saveForm();
        }

        /**
         * will be called by finish method to save order with an existing customer ID,
         * or a newly created one 
         * @param customerID
         */
        protected saveForm() {
            if (!this.validateOldAddressFields())
                return;

            var order = this.getSaveEntity([
                FormWizardSteps.HasoInfoAndContractApproval,
                FormWizardSteps.GeneralInformation,
                FormWizardSteps.InformationRequiredForTheReport
            ]);
            /*order.CustomerID = customerID;*/
            var self = this;

            SorAraBul.PropertyManagement.TenantDetailService.Update({
                EntityId: self.GId,
                Entity: this.createReportInfoEntity()
            }, response => {
                location.reload();
            });

            //Q.confirm('Form girdileri tamamlandı. Onay veriyor musunuz? (Uyarı : Onay verdiğiniz takdirde form üzerinde değişiklik yapabilmek için aynı ekran üzerinden talep oluşturmanız gerekir.)', () => {

            //    //SorAraBul.PropertyManagement.CompanyFormDataSpeakingPersonAndFilesService.CreateOrUpdate({
            //    //    EntityId: this.GId,
            //    //    Entity: this.getSaveEntity([FormWizardSteps.SpeakingPersonAndFi]) as SorAraBul.PropertyManagement.CompanyFormDataSpeakingPersonAndFilesRow
            //    //}, response => {
            //    //    location.reload();
            //    //},
            //    //{
            //    //    async: false
            //    //});
            //},
            //    {
            //        //onNo: () => this.dialogClose(),
            //        //onCancel: () => this.dialogClose(),
            //        //onClose: () => this.dialogClose()
            //    });

        }

        private createReportInfoEntity(): SorAraBul.PropertyManagement.TenantDetailRow {
            var entity = this.getSaveEntity([FormWizardSteps.InformationRequiredForTheReport]) as SorAraBul.PropertyManagement.TenantDetailRow;
            var years = Q.toId(this.form.OldAddressResidenceDurationYears.value) || 0;
            var months = Q.toId(this.form.OldAddressResidenceDurationRemainingMonths.value) || 0;
            var durationMonths = years * 12 + months;

            (entity as any).OldAddressResidenceDurationMonths = durationMonths > 0 ? durationMonths : null;
            delete (entity as any).OldAddressResidenceDurationYears;
            delete (entity as any).OldAddressResidenceDurationRemainingMonths;

            return entity;
        }

        private validateOldAddressFields(): boolean {
            var years = Q.toId(this.form.OldAddressResidenceDurationYears.value) || 0;
            var months = Q.toId(this.form.OldAddressResidenceDurationRemainingMonths.value) || 0;
            var hasDuration = years > 0 || months > 0;
            var hasAnyAddressValue =
                Q.toId(this.form.OldCityId.value) != null ||
                Q.toId(this.form.OldTownId.value) != null ||
                Q.toId(this.form.OldQuarterId.value) != null ||
                !!Q.trimToNull(this.form.OldAddress.value) ||
                hasDuration;

            if (!hasAnyAddressValue)
                return true;

            if (Q.toId(this.form.OldCityId.value) == null ||
                Q.toId(this.form.OldTownId.value) == null ||
                Q.toId(this.form.OldQuarterId.value) == null ||
                !Q.trimToNull(this.form.OldAddress.value) ||
                !hasDuration) {
                Q.notifyError("Mevcut oturduğunuz adres bilgileri girilecekse şehir, ilçe, mahalle, açık adres ve oturma süresi alanlarının tamamı doldurulmalıdır.");
                return false;
            }

            return true;
        }



    }

    // we define this enum to avoid magic step numbers
    export enum FormWizardSteps {
        HasoInfoAndContractApproval = 1,
        GeneralInformation = 2,
        InformationRequiredForTheReport = 3
    }
}
